module.exports = __webpack_public_path__ + "static/media/Artboard1.b0bf5670.png";